import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import CustomInput from './customInput';
import CustomSelect from './customSelect';
import CustomCheck from './customCheck';
import CustomRadio from './customRadio';
import { setPacientesCamposDinamicos } from '../../../../../state/actions/creators/pacientes.actioncreator';

interface CustomFieldsProps{
  intl: any,
  fields: any,
  values: any,
  hookForms: any,
  watch: boolean
}

function CustomFields({
  intl, fields, hookForms, values, watch
}: CustomFieldsProps) {
  const dispatch = useDispatch();

  const {
    register, trigger, setValue, errors,
  } = hookForms;
  useEffect(() => {
    values && values.forEach((value:any) => {
      setValue(`dinamicos.${value.campo_id}`, value.descripcion_pick);
    });
  }, [values]);
  const getCustomComponent = (props: any, field: any) => {
    switch (field?.propiedades?.tipo) {
      case 'Text':
        return (
          <CustomInput
            {...props}
            watch={watch}
            placeholder={field?.campo_descripcion}
          />
        );
      case 'Picklist':
        return (
          <CustomSelect
            {...props}
            watch={watch}
            placeholder={field?.campo_descripcion}
            values={field?.valores}
          />
        );
      case 'Multipicklist':
        return (
          <CustomCheck
            {...props}
            watch={watch}
            values={field?.valores}
          />
        );
      case 'radio':
        return (
          <CustomRadio
            {...props}
            watch={watch}
            values={field?.valores}
          />
        );
      default:
        return null;
    }
  };


  const requiredRule = (param: string) => ({
    required: {
      value: true,
      message: intl.formatMessage({ id: 'pacientes.generic.errors.required' }, {
        param,
      }),
    },
  });

  const fieldsToRender: Array<any> = [];
  let auxElements: Array<any> = [];

  fields.forEach((field: any, index: number) => {
    const { campo_descripcion, campo, campo_id } = field;
    const props = {
      className: '',
      title: campo_descripcion,
      name: campo_id,
      key: campo_id,
      value: values ? values[index]?.descripcion_pick : null,
      onChange: (value: string) => {
        setValue(`dinamicos.${field.campo_id}`, value);
        trigger(`dinamicos.${field.campo_id}`);
        dispatch(setPacientesCamposDinamicos({ campo_id: field.campo_id, valor: value }));
      },
      error: errors[`dinamicos.${field.campo_id}`],
    };

    if (field?.propiedades?.obligatorio) register(`dinamicos.${field.campo_id}`, requiredRule(field.campo_descripcion));
    else register(`dinamicos.${field.campo_id}`);

    switch (index % 2) {
      case 0:
        // props.className = 'margin-right';
        auxElements.push(getCustomComponent(props, field));
        break;
      case 1:
        // props.className = 'margin-left';
        auxElements.push(getCustomComponent(props, field));
        fieldsToRender.push((
          // eslint-disable-next-line react/no-array-index-key
          <div className="contact" key={index / 2}>
            {auxElements}
          </div>
        ));
        auxElements = [];
        break;
      default:
        break;
    }

    if (index === (fields.length - 1) && index % 2 !== 1) {
      fieldsToRender.push((
        // eslint-disable-next-line react/no-array-index-key
        <div className="contact" key={index / 2}>
          {auxElements}
        </div>
      ));
    }
  });


  return (
    <>
      {fieldsToRender}
    </>
  );
}


export default injectIntl(CustomFields);
